import { render, staticRenderFns } from "./order_data_trend_statistics.vue?vue&type=template&id=b0c1a99c&scoped=true"
import script from "./order_data_trend_statistics.vue?vue&type=script&lang=js"
export * from "./order_data_trend_statistics.vue?vue&type=script&lang=js"
import style0 from "./order_data_trend_statistics.vue?vue&type=style&index=0&id=b0c1a99c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c1a99c",
  null
  
)

export default component.exports